import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import { PREVIEW_PADDING } from "../PreviewFrameWithBranding/PreviewFrameWithBranding"

type Props = {
  event: DioboxEvent
}

const PageHeader = ({
  event: {
    portalShowPageHeader,
    portalTopNavTextColor,
    portalPageHeader,
    publicEventTitle,
  },
}: Props) => (
  <Box px={PREVIEW_PADDING} pb={5}>
    {portalShowPageHeader && (
      <>
        <Text fontSize="2xl" fontWeight="semibold" color={portalTopNavTextColor}>{portalPageHeader}</Text>
        <Text noOfLines={1} color={portalTopNavTextColor}>{publicEventTitle}</Text>
      </>
    )}
  </Box>
)

export default PageHeader
